import React, { ReactNode } from "react";
import { Card, CardBody, Container } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

type CatalogoPageLayoutProps = {
  title: string;
  description: string;
  helperText?: string;
  extraContent?: ReactNode;
};

const CatalogoPageLayout: React.FC<CatalogoPageLayoutProps> = ({
  title,
  description,
  helperText = "Muy pronto vas a poder gestionar este catálogo desde la misma pantalla.",
  extraContent,
}) => {
  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={title} pageTitle="Catálogos" description={description} />
        <Card className="mt-3">
          <CardBody>
            <p className="text-muted mb-0">{helperText}</p>
            {extraContent}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default CatalogoPageLayout;
